/**
 * Single source of truth for logo container intrinsic dimensions.
 * Must match the fallback values used in tailwind.config.ts for
 * width/height tokens (logo-box, logo-box-sm) to avoid layout/CLS drift.
 */
export const LOGO_BOX_WIDTH = 108;
export const LOGO_BOX_HEIGHT = 62;
export const LOGO_BOX_SM_WIDTH = 100;
export const LOGO_BOX_SM_HEIGHT = 57;

export const LOGO_BOX = { width: LOGO_BOX_WIDTH, height: LOGO_BOX_HEIGHT };
export const LOGO_BOX_SM = {
  width: LOGO_BOX_SM_WIDTH,
  height: LOGO_BOX_SM_HEIGHT,
};
